import React from "react";
import { View, Text } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { FontFamilies } from "@/constants/Typography";
import { Image } from "expo-image";
import Images from "@/assets/images";

const OnboardSlide2 = () => {
  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <Text style={styles.title}>
          {"Let's see how much you have unclaimed"}
        </Text>
        <Image source={Images.coin3d} style={styles.coinImage} contentFit="contain" />
        <Text style={styles.subtitle}>
          Just tell us which companies you've purchased from in the past.
        </Text>
      </View>
    </View>
  );
};

export default OnboardSlide2;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 8,
    justifyContent: "center",
  },
  content: {
    alignItems: "center",
    gap: 16,
  },
  coinImage: {
    width: 120,
    height: 120,
  },
  title: {
    fontFamily: FontFamilies.Inter.SemiBold,
    fontSize: 24,
    lineHeight: 30,
    color: "#161D14",
    textAlign: "center",
  },
  subtitle: {
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 15,
    lineHeight: 24,
    color: "#161D14",
    textAlign: "center",
    opacity: 0.7,
    letterSpacing: -0.3,
    width: 300,
  },
});
